import script from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=8f0f0694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f0f0694"]])

export default __exports__